"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var SharpDataService = __importStar(require("./SharpDataService"));
var RecentMoveDataService = __importStar(require("./RecentMoveDataService"));
var ValueDataService = __importStar(require("./ValueDataService"));
var DisplayService = __importStar(require("./DisplayService"));
var StatDataService = __importStar(require("./StatDataService"));
var RecordDataService = __importStar(require("./RecordDataService"));
exports.default = __assign(__assign(__assign(__assign(__assign(__assign({}, SharpDataService), RecentMoveDataService), ValueDataService), DisplayService), StatDataService), RecordDataService);

//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9iZXQtc2VydmljZXMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsbUVBQXVEO0FBQ3ZELDZFQUFpRTtBQUNqRSxtRUFBdUQ7QUFDdkQsK0RBQW1EO0FBQ25ELGlFQUFxRDtBQUNyRCxxRUFBeUQ7QUFFekQsNEVBQ0ssZ0JBQWdCLEdBQ2hCLHFCQUFxQixHQUNyQixnQkFBZ0IsR0FDaEIsY0FBYyxHQUNkLGVBQWUsR0FDZixpQkFBaUIsRUFDcEIiLCJmaWxlIjoiYmV0LXNlcnZpY2VzL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0ICogYXMgU2hhcnBEYXRhU2VydmljZSBmcm9tIFwiLi9TaGFycERhdGFTZXJ2aWNlXCI7XG5pbXBvcnQgKiBhcyBSZWNlbnRNb3ZlRGF0YVNlcnZpY2UgZnJvbSBcIi4vUmVjZW50TW92ZURhdGFTZXJ2aWNlXCI7XG5pbXBvcnQgKiBhcyBWYWx1ZURhdGFTZXJ2aWNlIGZyb20gXCIuL1ZhbHVlRGF0YVNlcnZpY2VcIjtcbmltcG9ydCAqIGFzIERpc3BsYXlTZXJ2aWNlIGZyb20gXCIuL0Rpc3BsYXlTZXJ2aWNlXCI7XG5pbXBvcnQgKiBhcyBTdGF0RGF0YVNlcnZpY2UgZnJvbSBcIi4vU3RhdERhdGFTZXJ2aWNlXCI7XG5pbXBvcnQgKiBhcyBSZWNvcmREYXRhU2VydmljZSBmcm9tIFwiLi9SZWNvcmREYXRhU2VydmljZVwiO1xuXG5leHBvcnQgZGVmYXVsdCB7XG4gIC4uLlNoYXJwRGF0YVNlcnZpY2UsXG4gIC4uLlJlY2VudE1vdmVEYXRhU2VydmljZSxcbiAgLi4uVmFsdWVEYXRhU2VydmljZSxcbiAgLi4uRGlzcGxheVNlcnZpY2UsXG4gIC4uLlN0YXREYXRhU2VydmljZSxcbiAgLi4uUmVjb3JkRGF0YVNlcnZpY2UsXG59O1xuIl19
